<div class="ajpes-tb-wrapper">
    <div class="dd-loader" *ngIf="loadingResults"></div>
    <input [placeholder]="checkPlaceholder()" class="sem-text-box" type="number"  [maxlength]="maxLength" min="0" (wheel)="$event.preventDefault()"
        [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"
        (input)="onTextChange($event)" ngModel [(ngModel)]="value"
        [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }" />
</div>